import React from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Link,
  Typography,
} from '@material-ui/core';

import { ReactComponent as DownIcon } from '../../../assets/img/icon/Down.svg';
import { appConfig } from '../../../config/app';

const ANSWER_FAQ = [
  {
    title: 'Productos',
    content: [
      {
        summary: '¿Qué tipos de seguros ofrecen?',
        details: (
          <Box>
            <Typography variant="body2">
              Tenemos una gran variedad de productos a la medida de tus
              necesidades para protegerte a vos, tu familia y patrimonio. Entrá,
              cotizá y contratá en{' '}
              <Link
                href={'https://www.answerseguros.com.ar'}
                rel="noopener"
                target="_blank"
                color="secondary"
              >
                www.answerseguros.com.ar
              </Link>
              <ul>
                <li>
                  Personas: Auto, Moto, Hogar, Accidentes Personales, Movilidad
                  (bicicleta, rollers y más), Vida y Vida Laboral.
                </li>
                <li>Empresas: Integral de Comercio.</li>
              </ul>
            </Typography>
          </Box>
        ),
      },
      {
        summary: '¿Cómo pago el seguro?',
        details: (
          <Box>
            <Typography variant="body2">
              El pago lo podés realizar desde la App, en la sección “Mis Pagos”.
              Si aún no lo hiciste, podés adherirte al débito automático.
            </Typography>
            <Typography variant="body2">
              Si tuviste algún inconveniente, podés contactarnos por WhatsApp,
              haciendo clic acá:{' '}
              <Link
                href={'https://api.whatsapp.com/send?phone=5491137650687'}
                rel="noopener"
                target="_blank"
                color="secondary"
              >
                +54 9 11 3765 0687.
              </Link>
            </Typography>
          </Box>
        ),
      },
      {
        summary: '¿Dónde puedo contratar un seguro?',
        details: (
          <Box>
            <Typography variant="body2">
              Ingresando a nuestra web{' '}
              <Link
                href={'https://www.answerseguros.com.ar'}
                rel="noopener"
                target="_blank"
                color="secondary"
              >
                www.answerseguros.com.ar
              </Link>
              , vas a poder cotizar y contratar en minutos tu próximo seguro.
            </Typography>
          </Box>
        ),
      },
      {
        summary:
          'Contraté mi seguro pero no me llega la póliza, ¿cómo la obtengo?',
        details: (
          <Box>
            <Typography variant="body2">
              Accedé a tu póliza desde la App, en la sección “Mis Pólizas”.
            </Typography>
            <Typography variant="body2">
              Si tuviste algún inconveniente, podés contactarnos por WhatsApp,
              haciendo clic acá:{' '}
              <Link
                href={'https://api.whatsapp.com/send?phone=5491137650687'}
                rel="noopener"
                target="_blank"
                color="secondary"
              >
                +54 9 11 3765 0687.
              </Link>
            </Typography>
          </Box>
        ),
      },
    ],
  },
  {
    title: 'Coberturas',
    content: [
      {
        summary: '¿Qué coberturas puedo contratar para mi vehículo?',
        details: (
          <Box>
            <Typography variant="body2">
              <Box> Podés elegir entre las siguientes opciones: </Box>
            </Typography>

            <Typography variant="body2">
              <ul>
                <li> Terceros completos </li>
                <li> Terceros completos clima </li>
                <li>
                  {' '}
                  Todo Riesgo Para más información, accedé a nuestra web{' '}
                  <Link
                    href={'https://www.answerseguros.com.ar'}
                    rel="noopener"
                    target="_blank"
                    color="secondary"
                  >
                    www.answerseguros.com.ar
                  </Link>
                </li>
              </ul>
            </Typography>
          </Box>
        ),
      },
      {
        summary: '¿Qué es la franquicia y cómo funciona?',
        details: (
          <Box>
            <Typography variant="body2">
              Si tenés un siniestro y contás con la cobertura Todo riesgo, la
              franquicia es la parte de la indemnización que deberás afrontar.
              Podés consultar en tu póliza cuál es el valor de franquicia que te
              corresponde abonar.
            </Typography>
          </Box>
        ),
      },
      {
        summary: '¿Estoy cubierto en países limítrofes?',
        details: (
          <Box>
            <Typography variant="body2">
              Sí, tu Seguro de Auto incluye protección en países limítrofes. Si
              querés más detalles, accedé a tu póliza 😉.
            </Typography>
          </Box>
        ),
      },
    ],
  },
  {
    title: 'Siniestros',
    content: [
      {
        summary: 'Necesito hacer una denuncia por mi auto o moto',
        details: (
          <Box>
            <Typography variant="body2">
              <Box>
                {' '}
                Podés hacerlo desde la App, en la sección “Quiero denunciar un
                siniestro”{' '}
              </Box>
            </Typography>

            <Typography variant="body2">
              <Box>
                Tené en cuenta lo siguiente antes de comenzar el trámite:
              </Box>
              <ul>
                <li>
                  {' '}
                  Realizá la denuncia dentro de las 72h de ocurrido el evento.{' '}
                </li>
                <li>
                  {' '}
                  Cuanta mayor cantidad de información puedas aportar, será
                  mejor para la gestión de tu caso.{' '}
                </li>
              </ul>
            </Typography>
          </Box>
        ),
      },
      {
        summary: 'Me chocaron, ¿Qué debo hacer?',
        details: (
          <Box>
            <Typography variant="body2">
              <Box> Deberás realizar con nosotros: </Box>
              <ul>
                <li>
                  {' '}
                  Denuncia administrativa, siguiendo los mismos pasos de la
                  pregunta anterior.{' '}
                </li>
                <li>
                  {' '}
                  Además, te brindaremos el Certificado de cobertura de tu
                  vehículo.{' '}
                </li>
              </ul>
            </Typography>

            <Typography variant="body2">
              <Box>
                Con esta documentación, deberás comunicarte con la compañía de
                la persona que te chocó.
              </Box>
            </Typography>

            <Typography variant="body2">
              <Box>
                Excepciones: Si chocaste con otro asegurado de answer Seguros o
                Galicia Seguros o tu siniestro ingresó dentro del convenio
                CLEAS, nosotros nos encargaremos de la tramitación.
              </Box>
            </Typography>
          </Box>
        ),
      },
    ],
  },
];

const SURA_FAQ = [
  {
    title: 'Productos',
    content: [
      {
        summary: '¿Qué tipos de seguros ofrecen?',
        details: (
          <Box>
            <Typography variant="body2">
              Tenemos una amplia gama de productos hechos a tu medida que nos
              permiten ofrecerte la mejor protección para vos, tu familia y
              patrimonio.
              <ul>
                <li>
                  {' '}
                  Personas y Familias: Tenemos productos enfocados en tus
                  necesidades individuales para asegurar lo que te rodea día a
                  día.{' '}
                </li>
                <li>
                  {' '}
                  Pymes y Grandes Empresas: Somos expertos en brindarte
                  coberturas que se adaptan a las características particulares
                  de tu industria.{' '}
                </li>
              </ul>
            </Typography>
          </Box>
        ),
      },
      {
        summary: '¿Cómo pago el seguro?',
        details: (
          <Box>
            <Typography variant="body2">
              El pago lo podés realizar a través de los siguientes Medios de
              Pago habilitados:
            </Typography>

            <Typography variant="body2">
              <Box fontWeight="bold"> Redes de Pago de Servicios </Box>
            </Typography>

            <Typography variant="body2">
              <ul>
                <li> Pago Fácil </li>
                <li> Rapipago </li>
                <li> Ripsa </li>
                <li> Provincia Net </li>
                <li> Pago Mis Cuentas </li>
              </ul>
            </Typography>

            <Typography variant="body2">
              <Box fontWeight="bold"> Tarjetas de Crédito </Box>
            </Typography>

            <Typography variant="body2">
              <ul>
                <li> Visa </li>
                <li> Mastercard </li>
                <li> American Express </li>
                <li> Diners </li>
                <li> Naranja </li>
                <li> Cencosud (Más – Mastercard) </li>
                <li> Cabal </li>
                <li> Nativa </li>
                <li> Electron </li>
              </ul>
            </Typography>

            <Typography variant="body2">
              <Box fontWeight="bold"> Agencias </Box>
            </Typography>

            <Typography variant="body2">
              <ul>
                <li>
                  En Casa Central y en las Agencias en todo el país. Revisá
                  nuestro{' '}
                  <Link
                    href={
                      'https://www.segurossura.com.ar/conoce-sura/nuestra-cultura/'
                    }
                    rel="noopener"
                    target="_blank"
                    color="secondary"
                  >
                    Mapa de Agencias
                  </Link>
                  .
                </li>
              </ul>
            </Typography>

            <Typography variant="body2">
              <Box fontWeight="bold"> CBU </Box>
            </Typography>

            <Typography variant="body2">
              <ul>
                <li> Débito por Clave Bancaria Única. </li>
              </ul>
            </Typography>
          </Box>
        ),
      },
      {
        summary: '¿Dónde puedo contratar un seguro?',
        details: (
          <Box>
            <Typography variant="body2">
              Podés comunicarte directamente al{' '}
              {appConfig?.FORMATED_CONTACT_PHONE} o contactarte con un Productor
              Asesor de Seguros.
            </Typography>
          </Box>
        ),
      },
      {
        summary:
          'Contraté mi seguro pero no me llega la póliza, ¿cómo la obtengo?',
        details: (
          <Box>
            <Typography variant="body2">
              En el caso del seguro automotor la podés obtener ingresando a
              nuestro Sitio de Clientes «Mis Pólizas» desde cualquier
              dispositivo (PC, tablet o teléfono celular). También la podés
              solicitar comunicándote al {appConfig?.FORMATED_CONTACT_PHONE}
            </Typography>
          </Box>
        ),
      },
      {
        summary: '¿Qué necesito para circular?',
        details: (
          <Box>
            <Typography variant="body2">
              Deberás circular teniendo a mano los siguientes documentos:
              <ul>
                <li>
                  Tarjeta de Circulación: se puede circular por todo el país con
                  la tarjeta de manera digital ya sea versión impresa o imagen
                  legible desde cualquier dispositivo móvil.
                  (Resol-SSN-219-.2018).
                </li>
                <li>
                  Tarjeta plástica (cédula verde o azul) que contiene los datos
                  del titular del vehículo e Identificación del vehículo
                  correspondiente.
                </li>
              </ul>
            </Typography>
          </Box>
        ),
      },
    ],
  },
  {
    title: 'Coberturas',
    content: [
      {
        summary: '¿Qué coberturas puedo contratar para mi vehículo?',
        details: (
          <Box>
            <Typography variant="body2">
              Tenemos una amplia gama de coberturas. Entre las más comunes
              encontrarás:
              <ul>
                <li>
                  {' '}
                  Cobertura "A": Responsabilidad Civil. Cubre daños a cosas y
                  personas ocasionadas por el vehículo asegurado.{' '}
                </li>
                <li>
                  {' '}
                  Cobertura "B": Responsabilidad Civil, Robo o Hurto Total,
                  Incendio Total y Destrucción Total.{' '}
                </li>
                <li>
                  {' '}
                  Cobertura "C": Responsabilidad Civil; Robo o Hurto Total y
                  Parcial; Incendio Total y Parcial y Destrucción Total.{' '}
                </li>
                <li>
                  Cobertura "D": Responsabilidad Civil; Robo o Hurto Total y
                  Parcial; Incendio Total y Parcial y Destrucción Total y
                  Parcial (con y sin Franquicia).
                </li>
              </ul>
            </Typography>
          </Box>
        ),
      },
      {
        summary: '¿Qué es la franquicia y cómo funciona?',
        details: (
          <Box>
            <Typography variant="body2">
              En la cobertura Todo riesgo "con franquicia", esta es la parte de
              la indemnización que no se paga, es decir que queda a cargo del
              asegurado. Es un monto que puede ser tanto fijo como variable (en
              función del precio del 0Km o del monto del siniestro) y que el
              asegurado elige al contratar su póliza.
            </Typography>
          </Box>
        ),
      },
      {
        summary: '¿Estoy cubierto es países limítrofes?',
        details: (
          <Box>
            <Typography variant="body2">
              Tu póliza ya incluye esta cobertura. Recordá que los beneficios
              adicionales rigen en toda la República Argentina y países
              limítrofes.
            </Typography>
          </Box>
        ),
      },
    ],
  },
  {
    title: 'Reporte de Siniestros',
    content: [
      {
        summary: '¿Cómo realizar una denuncia de seguro automotor?',
        details: (
          <Box>
            <Typography variant="body2">
              Para denunciar tu siniestro de forma fácil y rápida, podés:
              <ul>
                <li>
                  {' '}
                  Ingresar a nuestro Sitio de Clientes «Mis Pólizas» desde
                  cualquier dispositivo (PC, tablet o teléfono celular).{' '}
                </li>
                <li>
                  {' '}
                  A través de nuestra web a la plataforma web en Denuncia de
                  Siniestro.{' '}
                </li>
                <li>
                  {' '}
                  O descargar la aplicación desde tu dispositivo móvil,
                  disponible en Android y iOS.{' '}
                </li>
              </ul>
              También podés comunicarte con tu Productor Asesor de Seguros o
              bien con la casa central de Galicia Seguros, al{' '}
              {appConfig?.FORMATED_CONTACT_PHONE}.
            </Typography>

            <Typography variant="body2">
              En caso de encontrarte en países limítrofes, comunicate al
              0054-114-331-1555 y te orientarán sobre la forma más rápida y
              eficiente de realizar la denuncia.
            </Typography>

            <Typography variant="body2">
              <Box fontWeight="bold">
                Recordá que es de suma importancia contar con un relato completo
                de los hechos y datos de las personas y vehículos involucrados
                en el accidente.
              </Box>
            </Typography>
          </Box>
        ),
      },
      {
        summary: 'Tuve un choque, ¿qué tengo que hacer?',
        details: (
          <Box>
            <Typography variant="body2">
              <Box fontWeight="bold"> En caso de cobertura Todo Riesgo </Box>
            </Typography>

            <Typography variant="body2">
              <ul>
                <li>
                  {' '}
                  Ingresá a la sección de Daños Parciales y encontrá el detalle
                  de los pasos a seguir.{' '}
                </li>
              </ul>
            </Typography>

            <Typography variant="body2">
              <Box fontWeight="bold"> Tengo cobertura contra Terceros </Box>
            </Typography>

            <Typography variant="body2">
              <ul>
                <li>
                  Si querés realizar el reclamo en la compañía de seguros de la
                  persona que te chocó, Galicia Seguros te entregará un
                  certificado de cobertura y una copia de tu denuncia ya que te
                  lo pedirán en la otra compañía.
                </li>
                <li>
                  Si el caso lo justifica, te pueden solicitar fotos de tu
                  vehículo, cuidando que se observe la patente en ellas para
                  verificar los daños.
                </li>
              </ul>
            </Typography>
          </Box>
        ),
      },
      {
        summary:
          'En caso de robo de mi vehículo, ¿qué documentación debo presentar?',
        details: (
          <Box>
            <Typography variant="body2">
              {' '}
              Seguí los siguientes pasos:{' '}
            </Typography>
            <Typography variant="body2">
              <ul>
                <li> Dejá Constancia de la Denuncia Policial y Copia. </li>
                <li> Fotocopia del título o cédula verde. </li>
                <li> Último comprobante de pago del seguro. </li>
                <li>
                  {' '}
                  Registro de conductor de quien manejaba o dejó el vehículo en
                  el lugar del hecho.{' '}
                </li>
              </ul>
            </Typography>
          </Box>
        ),
      },
      {
        summary: '¿Qué es destrucción total?',
        details: (
          <Box>
            <Typography variant="body2">
              Se considera destrucción total del automóvil cuando el costo de
              las reparaciones por el daño sufrido en el siniestro supere el 80%
              del valor de plaza en el mercado del vehículo siniestrado.
            </Typography>
          </Box>
        ),
      },
      {
        summary: '¿Cuánto voy a cobrar por el robo de mi vehículo?',
        details: (
          <Box>
            <Typography variant="body2">
              La indemnización es el valor de reposición de la unidad; es decir,
              el valor de plaza que poseía el vehículo al momento del robo y se
              considerará la suma asegurada como tope máximo a indemnizar.
            </Typography>
          </Box>
        ),
      },
    ],
  },
  {
    title: 'Siniestros de terceros con asegurados Galicia Seguros',
    content: [
      {
        summary:
          'Me chocó un asegurado de Galicia Seguros, ¿cómo hago la denuncia?',
        details: (
          <Box>
            <Typography variant="body2">
              {' '}
              Para presentar la denuncia podés:{' '}
            </Typography>
            <Typography variant="body2">
              <ul>
                <li>
                  {' '}
                  En CABA enviar mail a {appConfig?.EMAIL} debido a que no se
                  gestiona atención a terceros en casa central.{' '}
                </li>
                <li>
                  {' '}
                  Para el interior del país, revisá la sucursal más cercana a tu
                  lugar de residencia.{' '}
                </li>
              </ul>
            </Typography>
          </Box>
        ),
      },
      {
        summary: '¿Qué información debo entregar para hacer la denuncia?',
        details: (
          <Box>
            <Typography variant="body2">
              {' '}
              Debés entregar la siguiente información:{' '}
            </Typography>
            <Typography variant="body2">
              <ul>
                <li> Dominio y/o póliza de nuestro asegurado. </li>
                <li> Fecha de ocurrencia del siniestro. </li>
                <li>
                  {' '}
                  Si conocés el número del siniestro correspondiente a Galicia
                  Seguros, agregalo.{' '}
                </li>
                <li>
                  {' '}
                  En caso de enviar la denuncia por mail, debés indicar los tres
                  puntos anteriores en el <strong>asunto</strong> del correo.{' '}
                </li>
                <li>
                  {' '}
                  Envianos un número de contacto, de preferencia celular para
                  contacto vía Whatsapp.{' '}
                </li>
              </ul>
            </Typography>
          </Box>
        ),
      },
      {
        summary: '¿Qué documentación debo presentar?',
        details: (
          <Box>
            <Typography variant="body2">
              <ul>
                <li>
                  {' '}
                  <strong>Certificado original de cobertura</strong>, emitido
                  por tu compañía de seguros.{' '}
                </li>
                <li>
                  {' '}
                  Copia de <strong>«Denuncia Administrativa»</strong> emitida
                  por tu compañía de seguros.{' '}
                </li>
                <li>
                  {' '}
                  En caso de no poseer seguro, entregar una{' '}
                  <strong>«Declaración jurada de no seguro»</strong>.{' '}
                </li>
                <li>
                  En caso de reclamar franquicia, entregar{' '}
                  <strong>«Carta de Franquicia»</strong> emitida emitida por tu
                  compañía de seguros (solo en caso de poseer cobertura Todo
                  Riesgo, debe incluir el costo total de la reparación,
                  diferenciando la franquicia y lo cubierto por su aseguradora).
                </li>
                <li>
                  {' '}
                  Imagen de <strong>cédula verde</strong> de la unidad
                  reclamante o de <strong>título de propiedad</strong>.{' '}
                </li>
                <li>
                  {' '}
                  <strong>Imagen de DNI</strong> del titular de la unidad
                  reclamante.{' '}
                </li>
                <li>
                  {' '}
                  <strong>
                    {' '}
                    Fotografías de las partes dañadas del vehículo y la patente{' '}
                  </strong>{' '}
                  de la unidad reclamante mínimo los 4 costados.{' '}
                </li>
                <li>
                  {' '}
                  <strong>Fotocopia del registro del conductor</strong> de la
                  unidad reclamante al momento de la ocurrencia.{' '}
                </li>
                <li>
                  {' '}
                  <strong>Presupuesto de los daños</strong> (opcional para
                  autos, obligatorio para motos).{' '}
                </li>
                <li>
                  <strong>Constancia de CBU de cuenta bancaria</strong>, si
                  desea que el pago de la eventual indemnización se realice por
                  transferencia bancaria.
                </li>
              </ul>
            </Typography>
          </Box>
        ),
      },
      {
        summary: '¿Qué documentos debo agregar en caso de lesiones a terceros?',
        details: (
          <Box>
            <Typography variant="body2"> Debés presentar: </Typography>
            <Typography variant="body2">
              <ul>
                <li>
                  {' '}
                  <strong>Denuncia policial</strong>, si la hubiere.{' '}
                </li>
                <li>
                  {' '}
                  <strong>Certificados médicos</strong> o constancias de
                  atención en hospital o guardia (opcional).{' '}
                </li>
              </ul>
            </Typography>
          </Box>
        ),
      },
    ],
  },
];

const CARD = appConfig?.SHORT_NAME === 'SURA' ? SURA_FAQ : ANSWER_FAQ;

const FAQ = () => {
  return (
    <>
      <Box mt={5} mb={4}>
        <Typography variant="h6"> Preguntas frecuentes </Typography>
      </Box>
      <Box>
        <Box>
          {CARD.map((card: any) => (
            <Box>
              <Box my={1}>
                <Typography> {card.title} </Typography>
              </Box>
              <Box mb={4}>
                {card.content.map((faq: any, index: number) => (
                  <Accordion key={index}>
                    <AccordionSummary expandIcon={<DownIcon />}>
                      <Typography>{faq.summary}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>{faq.details}</AccordionDetails>
                  </Accordion>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default FAQ;
